export const USER_CONTENTS = {
  header: 'Select User Type',
  subHeader: 'Please select the option that best describes you',
  users: [
    {
      key: 'guardian',
      name: 'parent',
      img: 'https://res.cloudinary.com/dxje0rp9f/image/upload/v1673601432/Link%20Park/undraw_pic_profile_re_7g2h_1_lraa9b.png',
      text: 'I am a Parent',
    },
    {
      key: 'student',
      name: 'student',
      img: 'https://res.cloudinary.com/dxje0rp9f/image/upload/v1673601432/Link%20Park/274_manager_outline_jbe8zx.png',
      text: 'I am a Student',
    },
  ],
}
